<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Veicoli Disponibili  </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="mt-1">
            <div class="row">
                <!--
                <div class="col-xs-12 col-12 col-sm-6 col-md-4 form-group">
                    <input type="text" class="form-control" placeholder="disponibile da"
                           disabled bsDatepicker [(bsValue)]="date_vehicle_available_from"/>
                </div>
                <div class="col-xs-12 col-12 col-sm-6 col-md-4 form-group">
                    <input type="text" class="form-control" placeholder="disponibile fino a"
                           disabled bsDatepicker [(bsValue)]="date_vehicle_available_to" />
                </div>
                -->
                <div class="col-12">
                    DAL : <strong>{{date_vehicle_available_from | date:'dd/MM/yyyy - HH:mm'}}</strong>
                    AL : <strong>{{date_vehicle_available_to | date:'dd/MM/yyyy - HH:mm'}}</strong>
                </div>

            </div>
            <div>
                <div>
                    <ng-container *ngFor="let v of returnedArray">
                        <button type="button"  [ngClass]="getColorStatus(v)"
                                (click)="assignVehicleAvailableInDateRange(v)"
                                class="btn btn-sm col-md-2 col-sm-2 col-2  m-1 p-0" style="min-width: 90px;" >
                            <i [ngClass]="getVehiclesTypeIcon(v.type.supertype.id)" class="fas"></i>&nbsp;
                            <small>{{v.plate}}</small></button>
                    </ng-container>
                </div>
                <pagination [totalItems]="available_vehicles.length" (pageChanged)="pageChanged($event)"
                            [maxSize]="maxSize" [itemsPerPage]="itemsPerPage"></pagination>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <!--<button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">Annulla</button>
    <button type="button"
            class="btn btn-secondary"
            [disabled]="dom_elements.assign_btn.is_running"
            data-dismiss="modal"
            (click)="setVehicle()">
      {{ dom_elements.assign_btn.is_running ? dom_elements.assign_btn.txt_run : dom_elements.assign_btn.txt_not_run}}</button>
      -->
    </div>
</ng-template>
